import React, { memo } from "react";
import useHowItWorksSection from "./index.hooks";
import { Container, Grid, Typography, Box } from "@material-ui/core";
import Instructions from "models/Istructions";
import AppButton from "../AppButton";
import { Trans } from "react-i18next";

type HowItWorksSectionProps = {};

const headline = "Come Funziona";
const buttonLabel = "Inizia subito";

const HowItWorksSection = ({}: HowItWorksSectionProps) => {
  const { styles, classes, atomicStyles, t } = useHowItWorksSection();

  return (
    <div className={styles.section} data-section="how-to">
      <Container className={styles.rootContainer} maxWidth="lg">
        <Box className={styles.titleContainer}>
          <Typography className={styles.title} variant="h1">
            {t(headline)}
          </Typography>
        </Box>
        <Grid container className={styles.stepsContainer} spacing={5}>
          {Instructions.data.map((item) => (
            <Grid key={item._id} item xs>
              <Box textAlign="center">
                <Typography className={styles.number} variant="h1">
                  {item._id}.
                </Typography>
              </Box>
              <Typography className={styles.desc} variant="h3">
                <Trans t={t} i18nKey={item.transKey}>
                  {item.description}
                </Trans>
              </Typography>
            </Grid>
          ))}
        </Grid>
        <Box mb={10}>
          <AppButton isCta path="/signup/">
            {t(buttonLabel)}
          </AppButton>
        </Box>
      </Container>
    </div>
  );
};

export default memo(HowItWorksSection);
